import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { LINKS_COLOR, PALE_GREY } from '../../theme';

const Container = styled.section`
  margin-top: 16px;
  border-top: 1px solid ${PALE_GREY};
  padding-top: 16px;
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: -0.1px;
`;

const Title = styled.h4`
  font-weight: bold;
  margin: 0 0 4px;
  font-size: 16px;
`;

const Text = styled.p`
  margin: 0;
  
  &+& {
    margin-top: 8px;
  }
`;

const TheoryAccessLink = styled.a`
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  background-color: ${LINKS_COLOR};
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
  display: block;
  padding: 10px 16px 14px;
  margin-top: 16px;
  text-decoration: none;
  
  &:hover, &:focus {
    color: #ffffff;
    text-decoration: none;
  }
`;

const TheoryAccessPromo = ({ schoolName }) => (
  <Container>
    <Title>Pas envie d’attendre?</Title>
    <Text>{`Commencez à réviser votre code de la route en ligne dès maintenant avec ${schoolName}!`}</Text>
    <Text>Cours, tests, plus de 2500 questions pour seulement 50€.</Text>
    <TheoryAccessLink href={`${window.location.pathname}/code-de-la-route`}>Je m’inscris au code</TheoryAccessLink>
  </Container>
);

TheoryAccessPromo.propTypes = {
  schoolName: PropTypes.string,
};

TheoryAccessPromo.defaultProps = {
  schoolName: '',
};

export { TheoryAccessPromo };
